<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
  [token]="token">

  <ng-container *ngIf="consulta">

    <h2 class="subtitle subtitle-danger d-flex ">
      <div class="w-100">CONDIÇÃO DO VEÍCULO</div>
      <div class="text-secondary text-nowrap">{{pontuacaoScore < 3 ? 'ALTA' : pontuacaoScore > 7 ? 'BAIXA' : 'MÉDIA'}}</div>
    </h2>
    <ul class="card-list-striped">
      
      <li class="bg-white flex-column p-0">
        <div class="p-2 w-100">
            <p><span class="badge badge-success badge-pill">1</span> Aparentemente inteiro</p>
            <p><span class="badge badge-primary badge-pill">2</span> Pequenos danos</p>
            <p><span class="badge badge-warning badge-pill">3</span> Médios danos</p>
            <p><span class="badge badge-danger badge-pill">4</span> Grandes danos</p>
        </div>
        
     </li>

     <li class="bg-white flex-column p-0">
      <div class="p-2 w-100">
        <span class="text-dark">CONDIÇÃO DO VEÍCULO</span>
        <h2 [ngClass]="{'text-success': condicaoVeiculo == 1, 'text-primary': condicaoVeiculo == 2, 'text-warning': condicaoVeiculo == 3, 'text-danger': condicaoVeiculo == 4 }">{{condicaoVeiculoDescricao || "NÃO INFORMADO"}}</h2> 
      </div>
      <div class="p-2 w-100">
        <app-sinalizador-nivel nivel="{{pontuacaoScore}}">
        </app-sinalizador-nivel>
      </div>
   </li>
   
    </ul>
    <h2 class="subtitle subtitle-danger d-flex ">
      <div class="w-100">ACEITAÇÃO DE SEGURO</div>
      <div class="text-secondary text-nowrap">{{pontuacaoScore < 3 ? 'ALTA' : pontuacaoScore > 7 ? 'BAIXA' : 'MÉDIA'}}</div>
    </h2>
    <ul class="card-list-striped">
      
      <li class="bg-white flex-column p-0">
        <div class="p-2 w-100">
          <span class="text-secondary">O veículo consultado possui aceitação de {{consulta?.aceitacaoVeiculo || '?%'}} no mercado.</span>
        </div>
        
     </li>

     <li class="bg-white flex-column  p-0">
      <div class="p-2 w-100">
        <span class="text-dark">ACEITAÇÃO DE SEGURO</span>
        <h2 [ngClass]="{'text-success': aceitacao > 90, 'text-primary': aceitacao <= 90 && aceitacao > 80, 'text-warning': aceitacao > 50 && aceitacao <= 80, 'text-danger': aceitacao <=50 }">{{consulta?.aceitacaoVeiculo || "NÃO INFORMADO"}}</h2> 
      </div>
      <div class="p-2 w-100">
        <app-sinalizador-nivel nivel="{{pontuacaoAceitacao}}">
        </app-sinalizador-nivel>
      </div>
    </li>
   
    </ul>

    <ul class="card-list-striped">
    
      <li class="bg-white flex-column  p-0">
        <h2 class="subtitle subtitle-danger d-flex w-100 mw-100">
          <div class="w-100">PERCENTUAL SOBRE A TABELA FIPE</div>
          <div class="text-secondary text-nowrap">
            {{pontuacaoFipe < 3 ? 'ALTA' : pontuacaoFipe > 7 ? 'BAIXA' : 'MÉDIA'}}
          </div>
        </h2>
        <div class="p-2">
          <app-sinalizador-nivel nivel="{{pontuacaoFipe}}">
          </app-sinalizador-nivel>
        </div>

      </li>

      <li class="bg-white flex-column p-0">
        <h2 class="subtitle subtitle-danger d-flex w-100 mw-100">
          <div class="w-100">NECESSIDADE DE VISTORIA ESPECIAL</div>
          <div class="text-secondary text-nowrap">
            {{pontuacaoVistoria < 3 ? 'BAIXA' : pontuacaoVistoria > 7 ? 'ALTA' : 'MÉDIA'}}
          </div>
        </h2>
        <div class="p-2">
          <app-sinalizador-nivel nivel="{{pontuacaoVistoria}}">
          </app-sinalizador-nivel>
        </div>
      </li>

    </ul>
    <ng-container *ngIf="consulta && consulta?.lista?.length>0">

      <ng-container *ngFor="let v of consulta.lista; let i = index">
        <h2 class="subtitle subtitle-warning ">HISTÓRICO DE VEÍCULOS OFERTADOS A LEILÃO</h2>
        <ul class="card-list-striped">
          <li><span class="text-secondary">PLACA</span> <span>{{v?.placa || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">CHASSI</span> <span>{{v?.chassi || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">MARCA</span> <span>{{v?.marca || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">MODELO</span> <span>{{v?.modelo || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">ANO DO MODELO</span> <span>{{v?.anoModelo || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">ANO DE FABRICAÇÃO</span> <span>{{v?.anoFabricacao || "NÃO INFORMADO"}}</span>
            <li><span class="text-secondary">COMBUSTÍVEL</span> <span>{{v?.combustivel || "NÃO INFORMADO"}}</span>
          </li>
          <li><span class="text-secondary">COR</span> <span>{{v?.cor || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">NUM. MOTOR</span> <span>{{v?.motor || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">NUM. CAMBIO</span> <span>{{v?.cambio || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">CATEGORIA DO VEÍCULO</span> <span>{{v?.categoriaVeiculo || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">LEILOEIRO</span> <span>{{v?.leiloeiro || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">COMITENTE</span> <span>{{v?.comitente || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">LOTE</span> <span>{{v?.lote || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">DATA DE LEILÃO</span> <span>{{v?.dataLeilao || "NÃO INFORMADO"}}</span>
          </li>
          <li><span class="text-secondary">SCORE</span> <span>{{v?.score || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">CONDIÇÃO GERAL DO VEÍCULO</span>
            <span>{{v?.condicaoGeralDoVeiculo || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">PÁTIO</span> <span>{{v?.patio || "NÃO INFORMADO"}}</span></li>
        </ul>
      </ng-container>

    </ng-container>

  </ng-container>

</app-card-consulta>
